import React, { useEffect } from "react";
import ResetPasswordForm from "containers/_components/reset-password-form";
import UpdatePasswordForm from "containers/_components/update-password-form";
import { inject, observer } from "mobx-react";
import { useQuery } from "library/core/utility/hooks";
import AccountSettingsStore from "../account-settings/stores/account-settings/AccountSettingsStore";
import TailwindFlex from "library/components/_tailwind/flex";
import TailwindBox from "library/components/_tailwind/box";

type Props = {
  accountSettingsStore?: AccountSettingsStore;
};

const SHOW_ALSO_FORGOT_USERNAME = false;

const ResetPassword: React.FC<Props> = ({ accountSettingsStore }) => {
  const { resetPasswordToken, setResetPasswordToken } = accountSettingsStore!;

  const query = useQuery();

  useEffect(() => {
    if (query.has("token") && !!query.get("token")) {
      setResetPasswordToken(query.get("token") as string);
    } else {
      setResetPasswordToken(undefined);
    }
  }, []);

  return (
    <TailwindFlex
      justifyContent={"justify-center"}
      alignItems={"items-center"}
      flexDirection={"flex-col"}
      className={["ForgotPassword"]}
      width={"w-full"}
      minWidth={"min-w-0"}
      padding={["px-4", "py-8"]}
      pseudoClasses={["xs:px-3", "xs:py-4"]}>
      <TailwindBox
        width={"w-full"}
        maxWidth={"max-w-md"}
        minWidth={"min-w-0"}
        margin={["mx-auto"]}>
        <TailwindBox width={"w-full"} margin={["mt-2", "mb-4"]}>
          {!resetPasswordToken ? (
            <ResetPasswordForm
              btnShapeVariant={["rounded-sm"]}
              showForgotUsername={SHOW_ALSO_FORGOT_USERNAME}
            />
          ) : (
            <UpdatePasswordForm
              buttonProps={{ borderRadius: "rounded-md" }}
              token={resetPasswordToken}
              showOldPassword={false}
            />
          )}
        </TailwindBox>
      </TailwindBox>
    </TailwindFlex>
  );
};

export default inject("accountSettingsStore")(observer(ResetPassword));
